import { render, staticRenderFns } from "./SearchResultView.vue?vue&type=template&id=0b457ab8&scoped=true&"
import script from "./SearchResultView.vue?vue&type=script&lang=js&"
export * from "./SearchResultView.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultView.vue?vue&type=style&index=0&id=0b457ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b457ab8",
  null
  
)

export default component.exports